import { TooltipOptions } from 'ng2-tooltip-directive';

export const CustomTooltipOptions: TooltipOptions = {
  zIndex: 1042,
};
